import { render, staticRenderFns } from "./UpdateCourseTimeDialog.vue?vue&type=template&id=136829cc&scoped=true"
import script from "./UpdateCourseTimeDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCourseTimeDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateCourseTimeDialog.vue?vue&type=style&index=0&id=136829cc&prod&lang=scss&scoped=true"
import style1 from "./UpdateCourseTimeDialog.vue?vue&type=style&index=1&id=136829cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136829cc",
  null
  
)

export default component.exports